import { getDemoWidgetValue } from 'calling-internal-common/utils/getDemoWidgetCallingProvider';
import { getExtensionsWidgetValue } from 'calling-internal-common/utils/getExtensionsCallingProvider';
export const getProviderFromLocalStorage = () => {
  const demoWidgetValue = getDemoWidgetValue();
  const extensionsWidgetValue = getExtensionsWidgetValue();
  return demoWidgetValue || extensionsWidgetValue;
};